import { makeAutoObservable } from 'mobx'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { UpgradePlanModalFinishStore } from './upgradePlanModalFinishStore'

export class UpgradePlanModalStore {
  private _upgradePlanModalFinishStore: UpgradePlanModalFinishStore

  constructor(private _entities: IEntitiesStore) {
    this._upgradePlanModalFinishStore = new UpgradePlanModalFinishStore(this._entities)

    makeAutoObservable(this)
  }

  openFinishModal = (planId: string) => {
    this._upgradePlanModalFinishStore.openFinishModal(planId)
  }
}
